import * as Yup from "yup";
import MESSAGE from "~/utils/messages";

export const schema = Yup.object().shape({
  Quantidade: Yup.string().required(MESSAGE.requiredField),
  Valor: Yup.string()
    .required(MESSAGE.requiredField)
    .test("positiveValue", MESSAGE.minValueProduct, (val) => {
      if (val) {
        const numberValue = parseFloat(
          val.replace(/[^\d,.]/g, "").replace(",", ".")
        );
        return numberValue > 0;
      }
      return false;
    })
    .test("maxDigits", MESSAGE.maxValueProduct, (val) => {
      if (val) {
        const cleanedValue = val.replace(/[^\d,.]/g, "").replace(",", ".");
        return cleanedValue >= 0.01 && cleanedValue <= 999.99 && cleanedValue.length <= 10;
      }
      return false;
    }),
  Marca: Yup.object().shape({
    label: Yup.string().required(MESSAGE.requiredSelect),
    value: Yup.string().required(MESSAGE.requiredSelect),
    // id: Yup.number().required(MESSAGE.requiredSelect),
  }),
  Produto: Yup.object().shape({
    label: Yup.string().required(MESSAGE.requiredSelect),
    value: Yup.string().required(MESSAGE.requiredSelect),
    id: Yup.number().required(MESSAGE.requiredSelect),
  }),
});
